// Turns a daemon ISO/RFC3339 timestamp into a short relative label ("5m ago")
// for the cramped phone UI. All math is UTC via getTime(), so the output is the
// same regardless of the phone's timezone; falls back to an absolute date once
// the event is a week or more old.

export function formatTimestamp(iso: string, now: Date = new Date()): string {
  if (!iso) return "";
  const date = new Date(iso);
  if (isNaN(date.getTime())) return ""; // unparseable input

  const ms = now.getTime() - date.getTime();
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (ms < 0 || seconds < 60) return "just now"; // future/clock skew counts as now
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return date.toISOString().slice(0, 10); // YYYY-MM-DD
}
